import {} from 'react'

import { Modal } from 'antd'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import IconButton from '../../../Components/antd/Buttons/IconButton'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { getTimezoneLessMoment } from '../../../utils/momentjs'

const LinkStudentModal = ({ student, onClose }) => {
  const t = useSelector(selectTranslate)

  return (
    <Modal
      title={t('Student already exists')}
      visible={student !== null}
      onCancel={onClose}
      footer={[
        <IconButton
          type='primary'
          key='close'
          icon={faCheck}
          text={t('OK')}
          onClick={onClose}
        />
      ]}
    >
      {student && (
        <>
          {/* eslint-disable-next-line */}
            <h3>{t('We found an existing student for email ${email}', { email: student.email })}</h3>
          <div>{t('Below you can see the details of the existing student:')}</div>
          <ul className='existing-student-details'>
            <li>
              <label>{t('Lastname')}</label>
              <b>{student.lastname || t('None')}</b>
            </li>
            <li>
              <label>{t('Firstname')}</label>
              <b>{student.firstname || t('None')}</b>
            </li>
            <li>
              <label>{t('Registration number')}</label>
              <b>{student.phoneNumber || t('None')}</b>
            </li>
            <li>
              <label>{t('Phone')}</label>
              <b>{student.matricule || t('None')}</b>
            </li>
            <li>
              <label>{t('Birthdate')}</label>
              <b>{student.birthdate ? getTimezoneLessMoment(student.birthdate).format('DD/MM/YYYY') : t('None')}</b>
            </li>
          </ul>
          <h3><b>{t('This existing student was linked to the section you selected.')}</b></h3>
        </>
      )}
    </Modal>
  )
}

export default LinkStudentModal
